const SvgBag = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M25.333 9.333V28H6.666V9.333zM6.667 8c-.736 0-1.333.597-1.333 1.333V28c0 .736.597 1.333 1.333 1.333h18.667c.736 0 1.333-.597 1.333-1.333V9.333c0-.736-.597-1.333-1.333-1.333zm4 0a5.333 5.333 0 1 1 10.666 0v6.667H20V8a4 4 0 0 0-8 0v6.667h-1.333z" />
  </svg>;
export default SvgBag;